import { api } from 'common/frontend/api';
import { chain } from 'lodash';

export const getAllCustomersBySearchTerm = (args: { shopId: string; searchTerm: string }) => {
	return Promise.all([
		searchAllCustomersByFirstName(args),
		searchAllCustomersByLastName(args),
		searchAllCustomersByPhone(args),
		searchAllCustomersByEmail(args),
	]).then((results) => {
		return chain(results)
			.flatten()
			.uniqBy((shopper) => shopper.id)
			.value();
	});
};

export const searchAllCustomersByFirstName = async (args: {
	shopId: string;
	searchTerm: string;
}) => {
	if (!args.searchTerm) return [];
	const lowerCase = args.searchTerm.toLowerCase().split(' ');
	const upperCase = args.searchTerm.charAt(0).toUpperCase() + args.searchTerm.slice(1);

	const splitNames = lowerCase.concat(upperCase);

	const query = api()
		.customers.get.where('merchantId', '==', args.shopId)
		.whereIn('firstName', 'in', splitNames)
		.get();
	return query;
};

export const searchAllCustomersByLastName = async (args: {
	shopId: string;
	searchTerm: string;
}) => {
	if (!args.searchTerm) return [];
	const lowerCase = args.searchTerm.toLowerCase().split(' ');
	const upperCase = args.searchTerm.charAt(0).toUpperCase() + args.searchTerm.slice(1);

	const splitNames = lowerCase.concat(upperCase);
	const query = api()
		.customers.get.where('merchantId', '==', args.shopId)
		.whereIn('lastName', 'in', splitNames)
		.get();
	return query;
};

export const searchAllCustomersByPhone = async (args: { shopId: string; searchTerm: string }) => {
	if (!args.searchTerm) return [];
	const query = api()
		.customers.get.where('merchantId', '==', args.shopId)
		.where('phone', '==', args.searchTerm)
		.get();
	return query;
};

export const searchAllCustomersByEmail = async (args: { shopId: string; searchTerm: string }) => {
	if (!args.searchTerm) return [];
	const query = api()
		.customers.get.where('merchantId', '==', args.shopId)
		.where('email', '==', args.searchTerm)
		.get();
	return query;
};
